import API from 'services/API/index';
import { map } from 'lodash';
import { moment } from '../../../../utils';

/**
 * todo: hasAdministrativeFines, hasUnexplainedPayments move to common request
 * @returns {AxiosPromise}
 */
export function getAdministrativeFines(options) {
  return API.request({
    method: 'GET',
    url: '/taxpayer/administrativeFines',
    params: options,
    mapper: (data) => {
      return {
        ...data,
        content: map(data.content, (fine) => {
          return {
            ...fine,
            documentDate: moment.fromServerDatetime(fine.documentDate),
            penaltyPaymentDate: moment.fromServerDatetime(fine.penaltyPaymentDate),
          };
        }),
      };
    },
  });
}
export function hasAdministrativeFines() {
  return API.request({
    method: 'GET',
    url: '/taxpayer/hasAdministrativeFines',
  });
}
export function getAdministrativeFilters() {
  return API.request({
    method: 'GET',
    url: '/taxpayer/administrativeFines/additionalInfo',
  });
}
